// Food database
export const foodsDatabase = [
  // FRUITS - USDA Verified Values
  {
    name: 'Apple',
    category: 'Fruits',
    oz: 5.3,
    cal: 86,
    protein: 0.4,
    carbs: 23,
    fat: 0.2,
  },
  {
    name: 'Banana',
    category: 'Fruits',
    oz: 3.5,
    cal: 89,
    protein: 1.1,
    carbs: 23,
    fat: 0.3,
  },
  {
    name: 'Orange',
    category: 'Fruits',
    oz: 5.2,
    cal: 47,
    protein: 0.9,
    carbs: 12,
    fat: 0.3,
  },
  {
    name: 'Strawberry',
    category: 'Fruits',
    oz: 5,
    cal: 32,
    protein: 0.6,
    carbs: 7.7,
    fat: 0.3,
  },
  {
    name: 'Blueberry',
    category: 'Fruits',
    oz: 5.3,
    cal: 57,
    protein: 0.7,
    carbs: 14.5,
    fat: 0.3,
  },
  {
    name: 'Grape',
    category: 'Fruits',
    oz: 3,
    cal: 51,
    protein: 0.5,
    carbs: 13.7,
    fat: 0.2,
  },
  {
    name: 'Watermelon',
    category: 'Fruits',
    oz: 5.3,
    cal: 30,
    protein: 0.6,
    carbs: 7.6,
    fat: 0.2,
  },
  {
    name: 'Mango',
    category: 'Fruits',
    oz: 3.5,
    cal: 54,
    protein: 0.7,
    carbs: 12,
    fat: 0.3,
  },
  {
    name: 'Pineapple',
    category: 'Fruits',
    oz: 5.6,
    cal: 43,
    protein: 0.4,
    carbs: 11.3,
    fat: 0.1,
  },
  {
    name: 'Peach',
    category: 'Fruits',
    oz: 5.3,
    cal: 42,
    protein: 0.7,
    carbs: 10,
    fat: 0.3,
  },
  {
    name: 'Pear',
    category: 'Fruits',
    oz: 6.2,
    cal: 84,
    protein: 0.6,
    carbs: 22.5,
    fat: 0.2,
  },
  {
    name: 'Kiwi',
    category: 'Fruits',
    oz: 2.6,
    cal: 61,
    protein: 1.1,
    carbs: 15,
    fat: 0.5,
  },
  {
    name: 'Avocado',
    category: 'Fruits',
    oz: 3.5,
    cal: 160,
    protein: 2,
    carbs: 9,
    fat: 15,
  },
  {
    name: 'Papaya',
    category: 'Fruits',
    oz: 3.5,
    cal: 43,
    protein: 0.8,
    carbs: 11,
    fat: 0.3,
  },
  {
    name: 'Coconut',
    category: 'Fruits',
    oz: 3.2,
    cal: 354,
    protein: 3.3,
    carbs: 9,
    fat: 35,
  },

  // VEGETABLES
  {
    name: 'Broccoli',
    category: 'Vegetables',
    oz: 3.5,
    cal: 34,
    protein: 2.8,
    carbs: 7,
    fat: 0.4,
  },
  {
    name: 'Carrot',
    category: 'Vegetables',
    oz: 3.5,
    cal: 41,
    protein: 0.9,
    carbs: 10,
    fat: 0.2,
  },
  {
    name: 'Spinach',
    category: 'Vegetables',
    oz: 3.5,
    cal: 23,
    protein: 2.9,
    carbs: 3.6,
    fat: 0.4,
  },
  {
    name: 'Lettuce',
    category: 'Vegetables',
    oz: 2,
    cal: 15,
    protein: 1.4,
    carbs: 2.9,
    fat: 0.2,
  },
  {
    name: 'Tomato',
    category: 'Vegetables',
    oz: 5.3,
    cal: 18,
    protein: 0.9,
    carbs: 3.9,
    fat: 0.2,
  },
  {
    name: 'Cucumber',
    category: 'Vegetables',
    oz: 3.5,
    cal: 16,
    protein: 0.7,
    carbs: 3.6,
    fat: 0.1,
  },
  {
    name: 'Bell Pepper',
    category: 'Vegetables',
    oz: 3.5,
    cal: 31,
    protein: 1,
    carbs: 7.2,
    fat: 0.3,
  },
  {
    name: 'Cauliflower',
    category: 'Vegetables',
    oz: 3.5,
    cal: 25,
    protein: 1.9,
    carbs: 4.9,
    fat: 0.3,
  },
  {
    name: 'Zucchini',
    category: 'Vegetables',
    oz: 3.5,
    cal: 21,
    protein: 1.4,
    carbs: 3.5,
    fat: 0.4,
  },
  {
    name: 'Celery',
    category: 'Vegetables',
    oz: 1.5,
    cal: 6,
    protein: 0.3,
    carbs: 1.2,
    fat: 0.1,
  },
  {
    name: 'Potato',
    category: 'Vegetables',
    oz: 5.3,
    cal: 77,
    protein: 2.1,
    carbs: 17,
    fat: 0.1,
  },
  {
    name: 'Sweet Potato',
    category: 'Vegetables',
    oz: 3.5,
    cal: 86,
    protein: 1.6,
    carbs: 20,
    fat: 0.1,
  },
  {
    name: 'Peas',
    category: 'Vegetables',
    oz: 3.5,
    cal: 81,
    protein: 5.4,
    carbs: 14,
    fat: 0.4,
  },
  {
    name: 'Corn',
    category: 'Vegetables',
    oz: 3.5,
    cal: 86,
    protein: 3.2,
    carbs: 19,
    fat: 1.4,
  },
  {
    name: 'Onion',
    category: 'Vegetables',
    oz: 3.5,
    cal: 40,
    protein: 1.1,
    carbs: 9,
    fat: 0.1,
  },
  {
    name: 'Garlic',
    category: 'Vegetables',
    oz: 0.1,
    cal: 4,
    protein: 0.2,
    carbs: 1,
    fat: 0,
  },
  {
    name: 'Asparagus',
    category: 'Vegetables',
    oz: 3.5,
    cal: 20,
    protein: 2.2,
    carbs: 3.7,
    fat: 0.1,
  },
  {
    name: 'Green Beans',
    category: 'Vegetables',
    oz: 3.5,
    cal: 31,
    protein: 1.8,
    carbs: 7,
    fat: 0.1,
  },
  {
    name: 'Brussels Sprouts',
    category: 'Vegetables',
    oz: 3.5,
    cal: 43,
    protein: 3.4,
    carbs: 8,
    fat: 0.3,
  },
  {
    name: 'Cabbage',
    category: 'Vegetables',
    oz: 3.5,
    cal: 25,
    protein: 1.3,
    carbs: 5.8,
    fat: 0.1,
  },

  // PROTEINS
  {
    name: 'Chicken Breast',
    category: 'Protein',
    oz: 3.5,
    cal: 165,
    protein: 31,
    carbs: 0,
    fat: 3.6,
  },
  {
    name: 'Ground Beef',
    category: 'Protein',
    oz: 3.5,
    cal: 217,
    protein: 23,
    carbs: 0,
    fat: 13,
  },
  {
    name: 'Salmon',
    category: 'Protein',
    oz: 3.5,
    cal: 208,
    protein: 20,
    carbs: 0,
    fat: 13,
  },
  {
    name: 'Tuna',
    category: 'Protein',
    oz: 3,
    cal: 132,
    protein: 29,
    carbs: 0,
    fat: 0.5,
  },
  {
    name: 'Egg',
    category: 'Protein',
    oz: 1.8,
    cal: 70,
    protein: 6.3,
    carbs: 0.4,
    fat: 5,
  },
  {
    name: 'Turkey Breast',
    category: 'Protein',
    oz: 3.5,
    cal: 135,
    protein: 29,
    carbs: 0,
    fat: 0.6,
  },
  {
    name: 'Pork Chop',
    category: 'Protein',
    oz: 3.5,
    cal: 160,
    protein: 27,
    carbs: 0,
    fat: 5,
  },
  {
    name: 'Beef Steak',
    category: 'Protein',
    oz: 3.5,
    cal: 250,
    protein: 26,
    carbs: 0,
    fat: 15,
  },
  {
    name: 'Shrimp',
    category: 'Protein',
    oz: 3.5,
    cal: 99,
    protein: 24,
    carbs: 0,
    fat: 0.3,
  },
  {
    name: 'Cod',
    category: 'Protein',
    oz: 3.5,
    cal: 82,
    protein: 18,
    carbs: 0,
    fat: 0.7,
  },
  {
    name: 'Tofu',
    category: 'Protein',
    oz: 3.5,
    cal: 76,
    protein: 8,
    carbs: 1.9,
    fat: 4.8,
  },
  {
    name: 'Tempeh',
    category: 'Protein',
    oz: 3.5,
    cal: 195,
    protein: 19,
    carbs: 7.6,
    fat: 11,
  },
  {
    name: 'Lentils',
    category: 'Protein',
    oz: 3.5,
    cal: 116,
    protein: 9,
    carbs: 20,
    fat: 0.4,
  },
  {
    name: 'Chickpeas',
    category: 'Protein',
    oz: 3.5,
    cal: 164,
    protein: 8.9,
    carbs: 27,
    fat: 2.6,
  },
  {
    name: 'Black Beans',
    category: 'Protein',
    oz: 3.5,
    cal: 132,
    protein: 8.9,
    carbs: 24,
    fat: 0.5,
  },

  // DAIRY
  {
    name: 'Milk',
    category: 'Dairy',
    oz: 8,
    cal: 61,
    protein: 3.2,
    carbs: 4.8,
    fat: 3.3,
  },
  {
    name: 'Yogurt',
    category: 'Dairy',
    oz: 5.3,
    cal: 59,
    protein: 10,
    carbs: 3.6,
    fat: 0.4,
  },
  {
    name: 'Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 115,
    protein: 7,
    carbs: 0.4,
    fat: 9.5,
  },
  {
    name: 'Cottage Cheese',
    category: 'Dairy',
    oz: 4.2,
    cal: 98,
    protein: 11,
    carbs: 3.9,
    fat: 5,
  },
  {
    name: 'Butter',
    category: 'Dairy',
    oz: 0.5,
    cal: 102,
    protein: 0.1,
    carbs: 0,
    fat: 11.5,
  },
  {
    name: 'Cream',
    category: 'Dairy',
    oz: 0.5,
    cal: 88,
    protein: 0.3,
    carbs: 0.7,
    fat: 9,
  },
  {
    name: 'Greek Yogurt',
    category: 'Dairy',
    oz: 5.3,
    cal: 59,
    protein: 10,
    carbs: 3.3,
    fat: 0.4,
  },
  {
    name: 'Mozzarella',
    category: 'Dairy',
    oz: 1,
    cal: 100,
    protein: 6.3,
    carbs: 0.6,
    fat: 7.5,
  },
  {
    name: 'Cheddar Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 115,
    protein: 7,
    carbs: 0.4,
    fat: 9.5,
  },

  // GRAINS & BREAD
  {
    name: 'Toast',
    category: 'Grains',
    oz: 1,
    cal: 80,
    protein: 2.5,
    carbs: 14,
    fat: 1,
  },
  {
    name: 'Bread',
    category: 'Grains',
    oz: 1,
    cal: 80,
    protein: 2.5,
    carbs: 15,
    fat: 1,
  },
  {
    name: 'White Rice',
    category: 'Grains',
    oz: 3.5,
    cal: 130,
    protein: 2.7,
    carbs: 28,
    fat: 0.3,
  },
  {
    name: 'Brown Rice',
    category: 'Grains',
    oz: 3.5,
    cal: 111,
    protein: 2.6,
    carbs: 23,
    fat: 0.9,
  },
  {
    name: 'Oatmeal',
    category: 'Grains',
    oz: 1,
    cal: 150,
    protein: 5,
    carbs: 27,
    fat: 3,
  },
  {
    name: 'Cereal',
    category: 'Grains',
    oz: 1,
    cal: 150,
    protein: 2,
    carbs: 34,
    fat: 1,
  },
  {
    name: 'Pasta',
    category: 'Grains',
    oz: 2,
    cal: 131,
    protein: 5,
    carbs: 25,
    fat: 1.1,
  },
  {
    name: 'Quinoa',
    category: 'Grains',
    oz: 3.5,
    cal: 120,
    protein: 4.4,
    carbs: 21,
    fat: 1.9,
  },
  {
    name: 'Tortilla',
    category: 'Grains',
    oz: 1.5,
    cal: 180,
    protein: 5,
    carbs: 31,
    fat: 5,
  },
  {
    name: 'Bagel',
    category: 'Grains',
    oz: 3.5,
    cal: 210,
    protein: 8,
    carbs: 41,
    fat: 1.1,
  },
  {
    name: 'Pancake',
    category: 'Grains',
    oz: 1.5,
    cal: 175,
    protein: 4.8,
    carbs: 33,
    fat: 2,
  },
  {
    name: 'Waffle',
    category: 'Grains',
    oz: 2,
    cal: 145,
    protein: 4,
    carbs: 20,
    fat: 5,
  },
  {
    name: 'Croissant',
    category: 'Grains',
    oz: 2,
    cal: 270,
    protein: 5,
    carbs: 24,
    fat: 14,
  },
  {
    name: 'Muffin',
    category: 'Grains',
    oz: 2,
    cal: 185,
    protein: 4,
    carbs: 30,
    fat: 5,
  },

  // NUTS & SEEDS
  {
    name: 'Almonds',
    category: 'Nuts',
    oz: 1,
    cal: 164,
    protein: 6,
    carbs: 6,
    fat: 14,
  },
  {
    name: 'Peanuts',
    category: 'Nuts',
    oz: 1,
    cal: 161,
    protein: 7,
    carbs: 6,
    fat: 14,
  },
  {
    name: 'Walnuts',
    category: 'Nuts',
    oz: 1,
    cal: 185,
    protein: 4.3,
    carbs: 4,
    fat: 19,
  },
  {
    name: 'Peanut Butter',
    category: 'Nuts',
    oz: 0.5,
    cal: 94,
    protein: 4,
    carbs: 3.5,
    fat: 8,
  },
  {
    name: 'Cashews',
    category: 'Nuts',
    oz: 1,
    cal: 155,
    protein: 5,
    carbs: 9,
    fat: 12,
  },
  {
    name: 'Sunflower Seeds',
    category: 'Nuts',
    oz: 1,
    cal: 165,
    protein: 6,
    carbs: 7,
    fat: 15,
  },
  {
    name: 'Pumpkin Seeds',
    category: 'Nuts',
    oz: 1,
    cal: 151,
    protein: 5,
    carbs: 5,
    fat: 13,
  },
  {
    name: 'Chia Seeds',
    category: 'Nuts',
    oz: 1,
    cal: 138,
    protein: 4.7,
    carbs: 12,
    fat: 8.7,
  },

  // FAST FOOD / PREPARED
  {
    name: 'Pizza Slice',
    category: 'Fast Food',
    oz: 3.5,
    cal: 285,
    protein: 12,
    carbs: 36,
    fat: 10,
  },
  {
    name: 'Hamburger',
    category: 'Fast Food',
    oz: 4.2,
    cal: 354,
    protein: 15,
    carbs: 33,
    fat: 15,
  },
  {
    name: 'Hot Dog',
    category: 'Fast Food',
    oz: 2,
    cal: 290,
    protein: 12,
    carbs: 23,
    fat: 16,
  },
  {
    name: 'French Fries',
    category: 'Fast Food',
    oz: 2.5,
    cal: 365,
    protein: 3.4,
    carbs: 48,
    fat: 17,
  },
  {
    name: 'Chicken Nuggets',
    category: 'Fast Food',
    oz: 3.5,
    cal: 320,
    protein: 17,
    carbs: 30,
    fat: 15,
  },
  {
    name: 'Taco',
    category: 'Fast Food',
    oz: 2,
    cal: 170,
    protein: 9,
    carbs: 14,
    fat: 9,
  },
  {
    name: 'Burrito',
    category: 'Fast Food',
    oz: 6,
    cal: 447,
    protein: 17,
    carbs: 63,
    fat: 14,
  },
  {
    name: 'Sandwich',
    category: 'Fast Food',
    oz: 3,
    cal: 400,
    protein: 18,
    carbs: 45,
    fat: 15,
  },
  {
    name: 'Donut',
    category: 'Fast Food',
    oz: 1.6,
    cal: 269,
    protein: 3.6,
    carbs: 29,
    fat: 15,
  },

  // BEVERAGES
  {
    name: 'Water',
    category: 'Beverages',
    oz: 8,
    cal: 0,
    protein: 0,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Coffee',
    category: 'Beverages',
    oz: 8,
    cal: 2,
    protein: 0.3,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Tea',
    category: 'Beverages',
    oz: 8,
    cal: 1,
    protein: 0,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Orange Juice',
    category: 'Beverages',
    oz: 8,
    cal: 47,
    protein: 0.7,
    carbs: 11,
    fat: 0.3,
  },
  {
    name: 'Soda',
    category: 'Beverages',
    oz: 12,
    cal: 140,
    protein: 0,
    carbs: 39,
    fat: 0,
  },
  {
    name: 'Beer',
    category: 'Beverages',
    oz: 12,
    cal: 153,
    protein: 1.6,
    carbs: 10.6,
    fat: 0,
  },
  {
    name: 'Wine',
    category: 'Beverages',
    oz: 5,
    cal: 85,
    protein: 0.1,
    carbs: 2.6,
    fat: 0,
  },
  {
    name: 'Protein Shake',
    category: 'Beverages',
    oz: 8,
    cal: 180,
    protein: 25,
    carbs: 5,
    fat: 3,
  },
  {
    name: 'Smoothie',
    category: 'Beverages',
    oz: 8,
    cal: 280,
    protein: 8,
    carbs: 50,
    fat: 4,
  },

  // SNACKS - CORRECTED USDA VALUES
  {
    name: 'Chips',
    category: 'Snacks',
    oz: 1,
    cal: 150,
    protein: 2,
    carbs: 15,
    fat: 9,
  },
  {
    name: 'Granola Bar',
    category: 'Snacks',
    oz: 1.4,
    cal: 180,
    protein: 5,
    carbs: 24,
    fat: 7,
  },
  {
    name: 'Crackers',
    category: 'Snacks',
    oz: 1,
    cal: 120,
    protein: 2.5,
    carbs: 18,
    fat: 4.5,
  },
  {
    name: 'Popcorn',
    category: 'Snacks',
    oz: 1,
    cal: 111,
    protein: 3.5,
    carbs: 11,
    fat: 6,
  },
  {
    name: 'Candy Bar',
    category: 'Snacks',
    oz: 1.4,
    cal: 250,
    protein: 4,
    carbs: 33,
    fat: 12,
  },
  {
    name: 'Cookie',
    category: 'Snacks',
    oz: 0.5,
    cal: 70,
    protein: 1,
    carbs: 10,
    fat: 3.5,
  },
  {
    name: 'Chocolate',
    category: 'Snacks',
    oz: 1,
    cal: 170,
    protein: 3,
    carbs: 16,
    fat: 9,
  },
  {
    name: 'Pretzel',
    category: 'Snacks',
    oz: 1,
    cal: 108,
    protein: 3,
    carbs: 21,
    fat: 1,
  },
  {
    name: 'Trail Mix',
    category: 'Snacks',
    oz: 1,
    cal: 150,
    protein: 5,
    carbs: 14,
    fat: 8,
  },

  // DESSERTS - CORRECTED VALUES
  {
    name: 'Ice Cream',
    category: 'Desserts',
    oz: 4.2,
    cal: 137,
    protein: 2.3,
    carbs: 16,
    fat: 7,
  },
  {
    name: 'Cake',
    category: 'Desserts',
    oz: 2,
    cal: 270,
    protein: 2,
    carbs: 40,
    fat: 10,
  },
  {
    name: 'Pie',
    category: 'Desserts',
    oz: 2.3,
    cal: 280,
    protein: 2,
    carbs: 35,
    fat: 14,
  },
  {
    name: 'Brownie',
    category: 'Desserts',
    oz: 1.2,
    cal: 250,
    protein: 3,
    carbs: 28,
    fat: 13,
  },
  {
    name: 'Cheesecake',
    category: 'Desserts',
    oz: 2.5,
    cal: 310,
    protein: 6,
    carbs: 28,
    fat: 19,
  },
  {
    name: 'Pudding',
    category: 'Desserts',
    oz: 5.3,
    cal: 150,
    protein: 2.5,
    carbs: 25,
    fat: 5,
  },
  {
    name: 'Jello',
    category: 'Desserts',
    oz: 3.5,
    cal: 62,
    protein: 1.5,
    carbs: 13,
    fat: 0,
  },

  // SAUCES & CONDIMENTS - CORRECTED VALUES
  {
    name: 'Mayo',
    category: 'Condiments',
    oz: 0.5,
    cal: 100,
    protein: 0,
    carbs: 0,
    fat: 11,
  },
  {
    name: 'Ketchup',
    category: 'Condiments',
    oz: 0.6,
    cal: 18,
    protein: 0.3,
    carbs: 4.2,
    fat: 0.1,
  },
  {
    name: 'Mustard',
    category: 'Condiments',
    oz: 0.5,
    cal: 9,
    protein: 0.5,
    carbs: 0.8,
    fat: 0.5,
  },
  {
    name: 'Olive Oil',
    category: 'Condiments',
    oz: 0.5,
    cal: 240,
    protein: 0,
    carbs: 0,
    fat: 27,
  },
  {
    name: 'Soy Sauce',
    category: 'Condiments',
    oz: 0.6,
    cal: 16,
    protein: 2.2,
    carbs: 1.5,
    fat: 0,
  },
  {
    name: 'Honey',
    category: 'Condiments',
    oz: 0.35,
    cal: 86,
    protein: 0.1,
    carbs: 23,
    fat: 0,
  },
  {
    name: 'Jam',
    category: 'Condiments',
    oz: 0.5,
    cal: 48,
    protein: 0,
    carbs: 12,
    fat: 0,
  },
  {
    name: 'Peanut Sauce',
    category: 'Condiments',
    oz: 0.5,
    cal: 240,
    protein: 9,
    carbs: 10,
    fat: 18,
  },

  // SOUPS & BROTHS
  {
    name: 'Chicken Soup',
    category: 'Soups',
    oz: 8,
    cal: 60,
    protein: 4,
    carbs: 6,
    fat: 2,
  },
  {
    name: 'Tomato Soup',
    category: 'Soups',
    oz: 8,
    cal: 74,
    protein: 2,
    carbs: 14,
    fat: 1.5,
  },
  {
    name: 'Vegetable Soup',
    category: 'Soups',
    oz: 8,
    cal: 45,
    protein: 2,
    carbs: 8,
    fat: 0.5,
  },
  {
    name: 'Beef Broth',
    category: 'Soups',
    oz: 8,
    cal: 17,
    protein: 2.7,
    carbs: 0,
    fat: 0.5,
  },

  // SPECIALTY ITEMS
  {
    name: 'Sushi Roll',
    category: 'Specialty',
    oz: 3.5,
    cal: 200,
    protein: 7,
    carbs: 35,
    fat: 2,
  },
  {
    name: 'Pad Thai',
    category: 'Specialty',
    oz: 8.8,
    cal: 357,
    protein: 9,
    carbs: 50,
    fat: 14,
  },
  {
    name: 'Kung Pao Chicken',
    category: 'Specialty',
    oz: 5.6,
    cal: 380,
    protein: 25,
    carbs: 12,
    fat: 28,
  },
  {
    name: 'Salmon Fillet',
    category: 'Specialty',
    oz: 5,
    cal: 280,
    protein: 25,
    carbs: 0,
    fat: 20,
  },
  {
    name: 'Steak Dinner',
    category: 'Specialty',
    oz: 8,
    cal: 500,
    protein: 50,
    carbs: 0,
    fat: 30,
  },
  {
    name: 'Spaghetti',
    category: 'Specialty',
    oz: 8.8,
    cal: 370,
    protein: 13,
    carbs: 60,
    fat: 8,
  },
];

// Quick add foods for common items
export const quickAddFoods = [
  {
    name: 'Apple',
    category: 'Fruits',
    oz: 5.3,
    cal: 95,
    protein: 0.5,
    carbs: 25,
    fat: 0.3,
  },
  {
    name: 'Banana',
    category: 'Fruits',
    oz: 3.5,
    cal: 105,
    protein: 1.3,
    carbs: 27,
    fat: 0.3,
  },
  {
    name: 'Chicken Breast',
    category: 'Protein',
    oz: 3.5,
    cal: 165,
    protein: 31,
    carbs: 0,
    fat: 3.6,
  },
  {
    name: 'Toast',
    category: 'Grains',
    oz: 1,
    cal: 80,
    protein: 2.5,
    carbs: 14,
    fat: 1,
  },
  {
    name: 'Egg',
    category: 'Protein',
    oz: 1.8,
    cal: 70,
    protein: 6.3,
    carbs: 0.4,
    fat: 5,
  },
  {
    name: 'Milk',
    category: 'Dairy',
    oz: 8,
    cal: 61,
    protein: 3.2,
    carbs: 4.8,
    fat: 3.3,
  },
  {
    name: 'Yogurt',
    category: 'Dairy',
    oz: 5.3,
    cal: 59,
    protein: 10,
    carbs: 3.6,
    fat: 0.4,
  },
  {
    name: 'Almonds',
    category: 'Nuts',
    oz: 1,
    cal: 579,
    protein: 21,
    carbs: 22,
    fat: 50,
  },
  {
    name: 'Broccoli',
    category: 'Vegetables',
    oz: 3.5,
    cal: 34,
    protein: 2.8,
    carbs: 7,
    fat: 0.4,
  },
  {
    name: 'Rice',
    category: 'Grains',
    oz: 3.5,
    cal: 130,
    protein: 2.7,
    carbs: 28,
    fat: 0.3,
  },
  {
    name: 'Salmon',
    category: 'Protein',
    oz: 3.5,
    cal: 208,
    protein: 20,
    carbs: 0,
    fat: 13,
  },
  {
    name: 'Peanut Butter',
    category: 'Nuts',
    oz: 0.5,
    cal: 588,
    protein: 25,
    carbs: 20,
    fat: 50,
  },

  // ADDITIONAL FRUITS
  {
    name: 'Blackberry',
    category: 'Fruits',
    oz: 5,
    cal: 43,
    protein: 1.4,
    carbs: 10,
    fat: 0.5,
  },
  {
    name: 'Raspberry',
    category: 'Fruits',
    oz: 4.4,
    cal: 52,
    protein: 1.2,
    carbs: 12,
    fat: 0.7,
  },
  {
    name: 'Cantaloupe',
    category: 'Fruits',
    oz: 5,
    cal: 35,
    protein: 0.9,
    carbs: 8.2,
    fat: 0.3,
  },
  {
    name: 'Honeydew',
    category: 'Fruits',
    oz: 5.5,
    cal: 36,
    protein: 0.5,
    carbs: 9,
    fat: 0.3,
  },
  {
    name: 'Grapefruit',
    category: 'Fruits',
    oz: 5.3,
    cal: 42,
    protein: 0.8,
    carbs: 11,
    fat: 0.1,
  },
  {
    name: 'Tangerine',
    category: 'Fruits',
    oz: 4,
    cal: 47,
    protein: 0.7,
    carbs: 12,
    fat: 0.3,
  },
  {
    name: 'Plum',
    category: 'Fruits',
    oz: 2.1,
    cal: 30,
    protein: 0.5,
    carbs: 7,
    fat: 0.2,
  },
  {
    name: 'Cherry',
    category: 'Fruits',
    oz: 3,
    cal: 63,
    protein: 1.1,
    carbs: 16,
    fat: 0.2,
  },
  {
    name: 'Pomegranate',
    category: 'Fruits',
    oz: 3.2,
    cal: 83,
    protein: 1.7,
    carbs: 19,
    fat: 1.2,
  },
  {
    name: 'Date',
    category: 'Fruits',
    oz: 1,
    cal: 66,
    protein: 0.4,
    carbs: 18,
    fat: 0.1,
  },
  {
    name: 'Dried Apricot',
    category: 'Fruits',
    oz: 0.5,
    cal: 67,
    protein: 2,
    carbs: 15,
    fat: 0.5,
  },
  {
    name: 'Raisin',
    category: 'Fruits',
    oz: 0.5,
    cal: 129,
    protein: 1.3,
    carbs: 34,
    fat: 0.3,
  },
  {
    name: 'Lime',
    category: 'Fruits',
    oz: 1.6,
    cal: 11,
    protein: 0.4,
    carbs: 3.5,
    fat: 0.2,
  },
  {
    name: 'Lemon',
    category: 'Fruits',
    oz: 3.5,
    cal: 17,
    protein: 0.6,
    carbs: 5,
    fat: 0.2,
  },
  {
    name: 'Passion Fruit',
    category: 'Fruits',
    oz: 1.8,
    cal: 36,
    protein: 1.5,
    carbs: 7.6,
    fat: 0.4,
  },
  {
    name: 'Dragon Fruit',
    category: 'Fruits',
    oz: 5.3,
    cal: 60,
    protein: 1.2,
    carbs: 13,
    fat: 0.4,
  },
  {
    name: 'Kiwi Fruit',
    category: 'Fruits',
    oz: 2.6,
    cal: 61,
    protein: 1.1,
    carbs: 15,
    fat: 0.5,
  },
  {
    name: 'Guava',
    category: 'Fruits',
    oz: 3.5,
    cal: 68,
    protein: 2.6,
    carbs: 14,
    fat: 0.9,
  },
  {
    name: 'Lychee',
    category: 'Fruits',
    oz: 2.6,
    cal: 63,
    protein: 0.8,
    carbs: 16,
    fat: 0.3,
  },
  {
    name: 'Prickly Pear',
    category: 'Fruits',
    oz: 3.5,
    cal: 42,
    protein: 0.7,
    carbs: 10,
    fat: 0.5,
  },
  {
    name: 'Elderberry',
    category: 'Fruits',
    oz: 3.5,
    cal: 73,
    protein: 0.7,
    carbs: 18,
    fat: 0.6,
  },

  // ADDITIONAL VEGETABLES
  {
    name: 'Artichoke',
    category: 'Vegetables',
    oz: 3.5,
    cal: 47,
    protein: 3.3,
    carbs: 10,
    fat: 0.1,
  },
  {
    name: 'Beet',
    category: 'Vegetables',
    oz: 3.5,
    cal: 43,
    protein: 1.7,
    carbs: 10,
    fat: 0.2,
  },
  {
    name: 'Radish',
    category: 'Vegetables',
    oz: 3.5,
    cal: 16,
    protein: 0.6,
    carbs: 3.5,
    fat: 0.1,
  },
  {
    name: 'Eggplant',
    category: 'Vegetables',
    oz: 3.5,
    cal: 35,
    protein: 0.8,
    carbs: 8.7,
    fat: 0.2,
  },
  {
    name: 'Pumpkin',
    category: 'Vegetables',
    oz: 3.5,
    cal: 26,
    protein: 1,
    carbs: 6.5,
    fat: 0.1,
  },
  {
    name: 'Kale',
    category: 'Vegetables',
    oz: 3.5,
    cal: 49,
    protein: 4.3,
    carbs: 9,
    fat: 0.9,
  },
  {
    name: 'Collard Greens',
    category: 'Vegetables',
    oz: 3.5,
    cal: 33,
    protein: 3.2,
    carbs: 6,
    fat: 0.6,
  },
  {
    name: 'Mustard Greens',
    category: 'Vegetables',
    oz: 3.5,
    cal: 27,
    protein: 3.2,
    carbs: 5,
    fat: 0.4,
  },
  {
    name: 'Bok Choy',
    category: 'Vegetables',
    oz: 3.5,
    cal: 13,
    protein: 1.5,
    carbs: 2.2,
    fat: 0.2,
  },
  {
    name: 'Okra',
    category: 'Vegetables',
    oz: 3.5,
    cal: 33,
    protein: 2,
    carbs: 7,
    fat: 0.2,
  },
  {
    name: 'Squash',
    category: 'Vegetables',
    oz: 3.5,
    cal: 37,
    protein: 1.5,
    carbs: 8.5,
    fat: 0.4,
  },
  {
    name: 'Turnip',
    category: 'Vegetables',
    oz: 3.5,
    cal: 28,
    protein: 0.9,
    carbs: 6.4,
    fat: 0.1,
  },
  {
    name: 'Rutabaga',
    category: 'Vegetables',
    oz: 3.5,
    cal: 37,
    protein: 1.2,
    carbs: 8.4,
    fat: 0.2,
  },
  {
    name: 'Parsnip',
    category: 'Vegetables',
    oz: 3.5,
    cal: 75,
    protein: 1.4,
    carbs: 18,
    fat: 0.3,
  },
  {
    name: 'Fennel',
    category: 'Vegetables',
    oz: 3.5,
    cal: 31,
    protein: 1.2,
    carbs: 7.3,
    fat: 0.2,
  },
  {
    name: 'Leek',
    category: 'Vegetables',
    oz: 3.5,
    cal: 54,
    protein: 1.5,
    carbs: 12,
    fat: 0.3,
  },
  {
    name: 'Endive',
    category: 'Vegetables',
    oz: 3.5,
    cal: 17,
    protein: 1.3,
    carbs: 3.3,
    fat: 0.1,
  },
  {
    name: 'Radicchio',
    category: 'Vegetables',
    oz: 3.5,
    cal: 23,
    protein: 1.2,
    carbs: 4.5,
    fat: 0.1,
  },
  {
    name: 'Watercress',
    category: 'Vegetables',
    oz: 3.5,
    cal: 25,
    protein: 2.3,
    carbs: 3.6,
    fat: 0.1,
  },
  {
    name: 'Swiss Chard',
    category: 'Vegetables',
    oz: 3.5,
    cal: 23,
    protein: 2.2,
    carbs: 4.3,
    fat: 0.2,
  },
  {
    name: 'Arugula',
    category: 'Vegetables',
    oz: 2,
    cal: 25,
    protein: 2.6,
    carbs: 3.7,
    fat: 0.7,
  },
  {
    name: 'Snap Peas',
    category: 'Vegetables',
    oz: 3.5,
    cal: 42,
    protein: 2.8,
    carbs: 7.6,
    fat: 0.2,
  },

  // ADDITIONAL PROTEINS & MEATS
  {
    name: 'Duck',
    category: 'Protein',
    oz: 3.5,
    cal: 337,
    protein: 19,
    carbs: 0,
    fat: 28,
  },
  {
    name: 'Turkey',
    category: 'Protein',
    oz: 3.5,
    cal: 150,
    protein: 29,
    carbs: 0,
    fat: 3.3,
  },
  {
    name: 'Lamb',
    category: 'Protein',
    oz: 3.5,
    cal: 294,
    protein: 26,
    carbs: 0,
    fat: 21,
  },
  {
    name: 'Veal',
    category: 'Protein',
    oz: 3.5,
    cal: 143,
    protein: 26,
    carbs: 0,
    fat: 3.5,
  },
  {
    name: 'Venison',
    category: 'Protein',
    oz: 3.5,
    cal: 158,
    protein: 30,
    carbs: 0,
    fat: 3.6,
  },
  {
    name: 'Bison',
    category: 'Protein',
    oz: 3.5,
    cal: 180,
    protein: 28,
    carbs: 0,
    fat: 7.6,
  },
  {
    name: 'Tilapia',
    category: 'Protein',
    oz: 3.5,
    cal: 128,
    protein: 26,
    carbs: 0,
    fat: 2.6,
  },
  {
    name: 'Trout',
    category: 'Protein',
    oz: 3.5,
    cal: 148,
    protein: 21,
    carbs: 0,
    fat: 6.5,
  },
  {
    name: 'Halibut',
    category: 'Protein',
    oz: 3.5,
    cal: 140,
    protein: 27,
    carbs: 0,
    fat: 2.9,
  },
  {
    name: 'Mahi Mahi',
    category: 'Protein',
    oz: 3.5,
    cal: 134,
    protein: 24,
    carbs: 0,
    fat: 3.8,
  },
  {
    name: 'Mackerel',
    category: 'Protein',
    oz: 3.5,
    cal: 305,
    protein: 19,
    carbs: 0,
    fat: 25,
  },
  {
    name: 'Sardine',
    category: 'Protein',
    oz: 3.5,
    cal: 208,
    protein: 25,
    carbs: 0,
    fat: 11,
  },
  {
    name: 'Anchovies',
    category: 'Protein',
    oz: 1,
    cal: 42,
    protein: 5.9,
    carbs: 0,
    fat: 1.9,
  },
  {
    name: 'Crab',
    category: 'Protein',
    oz: 3.5,
    cal: 111,
    protein: 20,
    carbs: 0,
    fat: 2,
  },
  {
    name: 'Lobster',
    category: 'Protein',
    oz: 3.5,
    cal: 112,
    protein: 19,
    carbs: 1.3,
    fat: 1.9,
  },
  {
    name: 'Oyster',
    category: 'Protein',
    oz: 3.5,
    cal: 81,
    protein: 8.4,
    carbs: 7,
    fat: 2.3,
  },
  {
    name: 'Mussel',
    category: 'Protein',
    oz: 3.5,
    cal: 172,
    protein: 24,
    carbs: 7.4,
    fat: 4.5,
  },
  {
    name: 'Clam',
    category: 'Protein',
    oz: 3.5,
    cal: 126,
    protein: 22,
    carbs: 4.4,
    fat: 1.7,
  },
  {
    name: 'Squid',
    category: 'Protein',
    oz: 3.5,
    cal: 158,
    protein: 28,
    carbs: 3,
    fat: 2.2,
  },
  {
    name: 'Scallop',
    category: 'Protein',
    oz: 3.5,
    cal: 112,
    protein: 20,
    carbs: 5,
    fat: 1.5,
  },
  {
    name: 'Bacon',
    category: 'Protein',
    oz: 0.5,
    cal: 161,
    protein: 12,
    carbs: 1.1,
    fat: 13,
  },
  {
    name: 'Ham',
    category: 'Protein',
    oz: 3.5,
    cal: 206,
    protein: 18,
    carbs: 2.1,
    fat: 15,
  },
  {
    name: 'Turkey Bacon',
    category: 'Protein',
    oz: 0.5,
    cal: 90,
    protein: 10,
    carbs: 0.4,
    fat: 5.2,
  },
  {
    name: 'Sausage',
    category: 'Protein',
    oz: 1,
    cal: 290,
    protein: 12,
    carbs: 1.6,
    fat: 27,
  },
  {
    name: 'Hot Dog',
    category: 'Protein',
    oz: 1.8,
    cal: 280,
    protein: 10,
    carbs: 2,
    fat: 25,
  },
  {
    name: 'Deli Turkey',
    category: 'Protein',
    oz: 1,
    cal: 30,
    protein: 5,
    carbs: 1,
    fat: 0.5,
  },
  {
    name: 'Deli Roast Beef',
    category: 'Protein',
    oz: 1,
    cal: 35,
    protein: 5.4,
    carbs: 0.2,
    fat: 1.5,
  },
  {
    name: 'Spam',
    category: 'Protein',
    oz: 1.5,
    cal: 176,
    protein: 7.4,
    carbs: 0.4,
    fat: 16,
  },
  {
    name: 'Pastrami',
    category: 'Protein',
    oz: 1,
    cal: 41,
    protein: 5.7,
    carbs: 0.5,
    fat: 1.9,
  },
  {
    name: 'Corned Beef',
    category: 'Protein',
    oz: 1,
    cal: 50,
    protein: 5.8,
    carbs: 0,
    fat: 2.8,
  },

  // ADDITIONAL DAIRY & CHEESE
  {
    name: 'Ricotta Cheese',
    category: 'Dairy',
    oz: 2,
    cal: 171,
    protein: 14,
    carbs: 6.4,
    fat: 10,
  },
  {
    name: 'Goat Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 130,
    protein: 9,
    carbs: 1.5,
    fat: 10,
  },
  {
    name: 'Feta Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 100,
    protein: 5,
    carbs: 1.2,
    fat: 8,
  },
  {
    name: 'Blue Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 100,
    protein: 6,
    carbs: 0.7,
    fat: 8,
  },
  {
    name: 'Swiss Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 107,
    protein: 7.6,
    carbs: 1.5,
    fat: 8,
  },
  {
    name: 'Provolone',
    category: 'Dairy',
    oz: 1,
    cal: 100,
    protein: 7.3,
    carbs: 0.6,
    fat: 7.6,
  },
  {
    name: 'Parmesan',
    category: 'Dairy',
    oz: 1,
    cal: 110,
    protein: 10,
    carbs: 1,
    fat: 7,
  },
  {
    name: 'Brie',
    category: 'Dairy',
    oz: 1,
    cal: 95,
    protein: 5.9,
    carbs: 0.5,
    fat: 7.9,
  },
  {
    name: 'Camembert',
    category: 'Dairy',
    oz: 1,
    cal: 85,
    protein: 5.3,
    carbs: 0.5,
    fat: 6.9,
  },
  {
    name: 'Cream Cheese',
    category: 'Dairy',
    oz: 1,
    cal: 99,
    protein: 2.2,
    carbs: 0.8,
    fat: 9.8,
  },
  {
    name: 'Cottage Cheese (Low Fat)',
    category: 'Dairy',
    oz: 4.2,
    cal: 81,
    protein: 14,
    carbs: 3.1,
    fat: 1.1,
  },
  {
    name: 'Sour Cream',
    category: 'Dairy',
    oz: 2,
    cal: 193,
    protein: 1.9,
    carbs: 3.6,
    fat: 20,
  },
  {
    name: 'Whipped Cream',
    category: 'Dairy',
    oz: 0.5,
    cal: 52,
    protein: 0.3,
    carbs: 0.4,
    fat: 5.5,
  },
  {
    name: 'Evaporated Milk',
    category: 'Dairy',
    oz: 2,
    cal: 169,
    protein: 8.4,
    carbs: 13,
    fat: 9.5,
  },
  {
    name: 'Condensed Milk',
    category: 'Dairy',
    oz: 1,
    cal: 135,
    protein: 3.3,
    carbs: 23,
    fat: 3.3,
  },

  // ADDITIONAL GRAINS & BREAD
  {
    name: 'Rye Bread',
    category: 'Grains',
    oz: 1,
    cal: 83,
    protein: 2.7,
    carbs: 15,
    fat: 1.1,
  },
  {
    name: 'Sourdough',
    category: 'Grains',
    oz: 1,
    cal: 78,
    protein: 2.5,
    carbs: 15,
    fat: 0.8,
  },
  {
    name: 'Whole Wheat Bread',
    category: 'Grains',
    oz: 1,
    cal: 80,
    protein: 4,
    carbs: 14,
    fat: 1.2,
  },
  {
    name: 'White Bread',
    category: 'Grains',
    oz: 1,
    cal: 79,
    protein: 2.3,
    carbs: 15,
    fat: 0.9,
  },
  {
    name: 'Multigrain Bread',
    category: 'Grains',
    oz: 1,
    cal: 82,
    protein: 3.5,
    carbs: 14,
    fat: 1.4,
  },
  {
    name: 'Pita Bread',
    category: 'Grains',
    oz: 2,
    cal: 165,
    protein: 5.5,
    carbs: 33,
    fat: 0.7,
  },
  {
    name: 'Naan Bread',
    category: 'Grains',
    oz: 2,
    cal: 262,
    protein: 8,
    carbs: 45,
    fat: 5,
  },
  {
    name: 'Flatbread',
    category: 'Grains',
    oz: 1,
    cal: 99,
    protein: 3,
    carbs: 18,
    fat: 1.5,
  },
  {
    name: 'Couscous',
    category: 'Grains',
    oz: 2.5,
    cal: 176,
    protein: 6,
    carbs: 36,
    fat: 0.3,
  },
  {
    name: 'Barley',
    category: 'Grains',
    oz: 3.5,
    cal: 354,
    protein: 12,
    carbs: 73,
    fat: 2.3,
  },
  {
    name: 'Millet',
    category: 'Grains',
    oz: 3.5,
    cal: 378,
    protein: 11,
    carbs: 73,
    fat: 4.2,
  },
  {
    name: 'Amaranth',
    category: 'Grains',
    oz: 3.5,
    cal: 371,
    protein: 14,
    carbs: 66,
    fat: 7,
  },
  {
    name: 'Buckwheat',
    category: 'Grains',
    oz: 3.5,
    cal: 343,
    protein: 13,
    carbs: 71,
    fat: 3.4,
  },
  {
    name: 'Ramen',
    category: 'Grains',
    oz: 2,
    cal: 192,
    protein: 7,
    carbs: 27,
    fat: 7,
  },
  {
    name: 'Spaghetti Squash',
    category: 'Grains',
    oz: 3.5,
    cal: 31,
    protein: 0.6,
    carbs: 7,
    fat: 0.5,
  },
  {
    name: 'Wheat Germ',
    category: 'Grains',
    oz: 1,
    cal: 108,
    protein: 8.3,
    carbs: 14,
    fat: 3,
  },
  {
    name: 'Bran',
    category: 'Grains',
    oz: 1,
    cal: 87,
    protein: 4.6,
    carbs: 25,
    fat: 1.3,
  },

  // ADDITIONAL NUTS & SEEDS
  {
    name: 'Macadamia Nuts',
    category: 'Nuts',
    oz: 1,
    cal: 718,
    protein: 7.9,
    carbs: 13.8,
    fat: 76,
  },
  {
    name: 'Brazil Nuts',
    category: 'Nuts',
    oz: 1,
    cal: 656,
    protein: 14,
    carbs: 12,
    fat: 66,
  },
  {
    name: 'Pecan',
    category: 'Nuts',
    oz: 1,
    cal: 691,
    protein: 9.2,
    carbs: 13.9,
    fat: 71.97,
  },
  {
    name: 'Pistachio',
    category: 'Nuts',
    oz: 1,
    cal: 560,
    protein: 21,
    carbs: 27,
    fat: 45,
  },
  {
    name: 'Hazelnut',
    category: 'Nuts',
    oz: 1,
    cal: 628,
    protein: 15,
    carbs: 16,
    fat: 60,
  },
  {
    name: 'Coconut Oil',
    category: 'Nuts',
    oz: 0.5,
    cal: 251,
    protein: 0,
    carbs: 0,
    fat: 28,
  },
  {
    name: 'Sesame Seeds',
    category: 'Nuts',
    oz: 1,
    cal: 563,
    protein: 17,
    carbs: 23,
    fat: 49,
  },
  {
    name: 'Flax Seeds',
    category: 'Nuts',
    oz: 1,
    cal: 534,
    protein: 18,
    carbs: 28,
    fat: 42,
  },
  {
    name: 'Hemp Seeds',
    category: 'Nuts',
    oz: 1,
    cal: 567,
    protein: 31,
    carbs: 12,
    fat: 48,
  },
  {
    name: 'Tahini',
    category: 'Nuts',
    oz: 0.5,
    cal: 178,
    protein: 5,
    carbs: 6.4,
    fat: 17,
  },
  {
    name: 'Almond Butter',
    category: 'Nuts',
    oz: 0.5,
    cal: 186,
    protein: 6.3,
    carbs: 6.5,
    fat: 17,
  },
  {
    name: 'Cashew Butter',
    category: 'Nuts',
    oz: 0.5,
    cal: 186,
    protein: 5.2,
    carbs: 7.7,
    fat: 16,
  },

  // FAST FOOD CHAINS
  {
    name: 'Big Mac',
    category: 'Fast Food',
    oz: 7.6,
    cal: 563,
    protein: 26,
    carbs: 46,
    fat: 30,
  },
  {
    name: 'Whopper',
    category: 'Fast Food',
    oz: 8.1,
    cal: 659,
    protein: 36,
    carbs: 52,
    fat: 39,
  },
  {
    name: 'Chicken McNuggets (6)',
    category: 'Fast Food',
    oz: 3.3,
    cal: 280,
    protein: 17,
    carbs: 15,
    fat: 17,
  },
  {
    name: 'Filet O Fish',
    category: 'Fast Food',
    oz: 5,
    cal: 399,
    protein: 16,
    carbs: 40,
    fat: 19,
  },
  {
    name: 'McFlurry',
    category: 'Fast Food',
    oz: 5.3,
    cal: 400,
    protein: 8,
    carbs: 56,
    fat: 15,
  },
  {
    name: 'Chick-fil-A Sandwich',
    category: 'Fast Food',
    oz: 3.5,
    cal: 440,
    protein: 41,
    carbs: 41,
    fat: 17,
  },
  {
    name: 'KFC Fried Chicken',
    category: 'Fast Food',
    oz: 3.5,
    cal: 320,
    protein: 30,
    carbs: 16,
    fat: 17,
  },
  {
    name: 'Popeyes Chicken Sandwich',
    category: 'Fast Food',
    oz: 4.4,
    cal: 790,
    protein: 29,
    carbs: 65,
    fat: 39,
  },
  {
    name: 'Subway 6" Turkey',
    category: 'Fast Food',
    oz: 6,
    cal: 280,
    protein: 18,
    carbs: 41,
    fat: 4.5,
  },
  {
    name: 'Chipotle Bowl',
    category: 'Fast Food',
    oz: 14,
    cal: 710,
    protein: 43,
    carbs: 66,
    fat: 28,
  },
  {
    name: 'Panera Bread Mac & Cheese',
    category: 'Fast Food',
    oz: 9,
    cal: 690,
    protein: 24,
    carbs: 66,
    fat: 36,
  },
  {
    name: "Wendy's Single",
    category: 'Fast Food',
    oz: 5.5,
    cal: 420,
    protein: 25,
    carbs: 37,
    fat: 20,
  },
  {
    name: "Arby's Roast Beef",
    category: 'Fast Food',
    oz: 5.3,
    cal: 360,
    protein: 21,
    carbs: 34,
    fat: 17,
  },
  {
    name: 'Taco Bell Crunchwrap',
    category: 'Fast Food',
    oz: 5.2,
    cal: 530,
    protein: 16,
    carbs: 49,
    fat: 30,
  },
  {
    name: 'In-N-Out Double Double',
    category: 'Fast Food',
    oz: 7,
    cal: 670,
    protein: 37,
    carbs: 39,
    fat: 41,
  },
  {
    name: 'Five Guys Burger',
    category: 'Fast Food',
    oz: 7.5,
    cal: 840,
    protein: 44,
    carbs: 66,
    fat: 51,
  },
  {
    name: 'Smashburger',
    category: 'Fast Food',
    oz: 6,
    cal: 640,
    protein: 38,
    carbs: 43,
    fat: 38,
  },
  {
    name: 'Shake Shack Burger',
    category: 'Fast Food',
    oz: 5.8,
    cal: 490,
    protein: 28,
    carbs: 41,
    fat: 25,
  },
  {
    name: 'Chick-fil-A Waffle Fries',
    category: 'Fast Food',
    oz: 2.5,
    cal: 320,
    protein: 4,
    carbs: 42,
    fat: 15,
  },
  {
    name: "McDonald's Fries Small",
    category: 'Fast Food',
    oz: 2.6,
    cal: 220,
    protein: 2.7,
    carbs: 29,
    fat: 11,
  },

  // BEVERAGES & DRINKS
  {
    name: 'Coca Cola',
    category: 'Beverages',
    oz: 12,
    cal: 140,
    protein: 0,
    carbs: 39,
    fat: 0,
  },
  {
    name: 'Pepsi',
    category: 'Beverages',
    oz: 12,
    cal: 150,
    protein: 0,
    carbs: 41,
    fat: 0,
  },
  {
    name: 'Sprite',
    category: 'Beverages',
    oz: 12,
    cal: 140,
    protein: 0,
    carbs: 38,
    fat: 0,
  },
  {
    name: 'Apple Juice',
    category: 'Beverages',
    oz: 8,
    cal: 96,
    protein: 0.1,
    carbs: 24,
    fat: 0.3,
  },
  {
    name: 'Cranberry Juice',
    category: 'Beverages',
    oz: 8,
    cal: 116,
    protein: 0,
    carbs: 29,
    fat: 0.1,
  },
  {
    name: 'Grape Juice',
    category: 'Beverages',
    oz: 8,
    cal: 152,
    protein: 0,
    carbs: 36,
    fat: 0.2,
  },
  {
    name: 'Grapefruit Juice',
    category: 'Beverages',
    oz: 8,
    cal: 96,
    protein: 1.5,
    carbs: 23,
    fat: 0.2,
  },
  {
    name: 'Tomato Juice',
    category: 'Beverages',
    oz: 8,
    cal: 41,
    protein: 1.9,
    carbs: 10,
    fat: 0.1,
  },
  {
    name: 'Coconut Water',
    category: 'Beverages',
    oz: 8,
    cal: 46,
    protein: 2.2,
    carbs: 9,
    fat: 1.1,
  },
  {
    name: 'Almond Milk',
    category: 'Beverages',
    oz: 8,
    cal: 39,
    protein: 1.5,
    carbs: 1.5,
    fat: 3,
  },
  {
    name: 'Oat Milk',
    category: 'Beverages',
    oz: 8,
    cal: 80,
    protein: 2,
    carbs: 10,
    fat: 2.5,
  },
  {
    name: 'Soy Milk',
    category: 'Beverages',
    oz: 8,
    cal: 81,
    protein: 6.8,
    carbs: 4.3,
    fat: 4.6,
  },
  {
    name: 'Rice Milk',
    category: 'Beverages',
    oz: 8,
    cal: 113,
    protein: 0.7,
    carbs: 22,
    fat: 2.4,
  },
  {
    name: 'Lemonade',
    category: 'Beverages',
    oz: 8,
    cal: 99,
    protein: 0.1,
    carbs: 26,
    fat: 0.1,
  },
  {
    name: 'Iced Tea',
    category: 'Beverages',
    oz: 8,
    cal: 76,
    protein: 0,
    carbs: 19,
    fat: 0.1,
  },
  {
    name: 'Energy Drink',
    category: 'Beverages',
    oz: 8,
    cal: 110,
    protein: 0,
    carbs: 27,
    fat: 0,
  },
  {
    name: 'Sports Drink',
    category: 'Beverages',
    oz: 8,
    cal: 63,
    protein: 0,
    carbs: 16,
    fat: 0,
  },
  {
    name: 'Kombucha',
    category: 'Beverages',
    oz: 8,
    cal: 30,
    protein: 0.4,
    carbs: 6,
    fat: 0,
  },
  {
    name: 'Milkshake',
    category: 'Beverages',
    oz: 10,
    cal: 500,
    protein: 8,
    carbs: 86,
    fat: 17,
  },
  {
    name: 'Horchata',
    category: 'Beverages',
    oz: 8,
    cal: 150,
    protein: 1,
    carbs: 27,
    fat: 5,
  },

  // SNACKS & SIDES
  {
    name: 'Doritos',
    category: 'Snacks',
    oz: 1,
    cal: 150,
    protein: 2,
    carbs: 16,
    fat: 9,
  },
  {
    name: 'Cheetos',
    category: 'Snacks',
    oz: 1,
    cal: 160,
    protein: 2,
    carbs: 15,
    fat: 10,
  },
  {
    name: "Lay's Classic Chips",
    category: 'Snacks',
    oz: 1,
    cal: 160,
    protein: 2,
    carbs: 15,
    fat: 10,
  },
  {
    name: 'Kettle Chips',
    category: 'Snacks',
    oz: 1,
    cal: 150,
    protein: 2,
    carbs: 16,
    fat: 8,
  },
  {
    name: 'Pringles',
    category: 'Snacks',
    oz: 0.7,
    cal: 152,
    protein: 1.3,
    carbs: 15,
    fat: 10,
  },
  {
    name: 'Rice Cakes',
    category: 'Snacks',
    oz: 1,
    cal: 35,
    protein: 0.7,
    carbs: 7.3,
    fat: 0.3,
  },
  {
    name: 'Ritz Crackers',
    category: 'Snacks',
    oz: 0.5,
    cal: 80,
    protein: 1,
    carbs: 9,
    fat: 4.5,
  },
  {
    name: 'Wheat Thins',
    category: 'Snacks',
    oz: 0.5,
    cal: 67,
    protein: 1.3,
    carbs: 9,
    fat: 2.5,
  },
  {
    name: 'Cheez-Its',
    category: 'Snacks',
    oz: 0.5,
    cal: 70,
    protein: 1.2,
    carbs: 8,
    fat: 3.5,
  },
  {
    name: 'Saltines',
    category: 'Snacks',
    oz: 0.5,
    cal: 52,
    protein: 1,
    carbs: 8.8,
    fat: 1.3,
  },
  {
    name: 'Beef Jerky',
    category: 'Snacks',
    oz: 1,
    cal: 116,
    protein: 24,
    carbs: 3,
    fat: 0.5,
  },
  {
    name: 'Pepperoni Slices',
    category: 'Snacks',
    oz: 1,
    cal: 140,
    protein: 6,
    carbs: 0.7,
    fat: 12,
  },
  {
    name: 'Mixed Nuts',
    category: 'Snacks',
    oz: 1,
    cal: 560,
    protein: 18,
    carbs: 24,
    fat: 48,
  },
  {
    name: 'Chex Mix',
    category: 'Snacks',
    oz: 1,
    cal: 152,
    protein: 4,
    carbs: 16,
    fat: 7,
  },
  {
    name: 'Goldfish Crackers',
    category: 'Snacks',
    oz: 0.5,
    cal: 70,
    protein: 1.5,
    carbs: 8,
    fat: 3,
  },
  {
    name: 'Fruit Roll-Up',
    category: 'Snacks',
    oz: 0.5,
    cal: 50,
    protein: 0,
    carbs: 12,
    fat: 0.5,
  },
  {
    name: 'Fruit by the Foot',
    category: 'Snacks',
    oz: 0.75,
    cal: 80,
    protein: 0,
    carbs: 18,
    fat: 0.5,
  },
  {
    name: 'Fruit Snacks',
    category: 'Snacks',
    oz: 1,
    cal: 100,
    protein: 1.5,
    carbs: 22,
    fat: 1,
  },
  {
    name: 'String Cheese',
    category: 'Snacks',
    oz: 1,
    cal: 80,
    protein: 6.5,
    carbs: 0.6,
    fat: 6,
  },
  {
    name: 'Cheese Puffs',
    category: 'Snacks',
    oz: 1,
    cal: 160,
    protein: 2,
    carbs: 15,
    fat: 10,
  },

  // DESSERTS & SWEETS
  {
    name: 'Chocolate Chip Cookie',
    category: 'Desserts',
    oz: 0.5,
    cal: 140,
    protein: 2,
    carbs: 18,
    fat: 7,
  },
  {
    name: 'Oreo Cookie',
    category: 'Desserts',
    oz: 0.5,
    cal: 53,
    protein: 0.7,
    carbs: 7,
    fat: 2.5,
  },
  {
    name: 'Brownies',
    category: 'Desserts',
    oz: 1,
    cal: 405,
    protein: 5.5,
    carbs: 47,
    fat: 21,
  },
  {
    name: 'Tiramisu',
    category: 'Desserts',
    oz: 3,
    cal: 352,
    protein: 5,
    carbs: 30,
    fat: 24,
  },
  {
    name: 'Mousse',
    category: 'Desserts',
    oz: 3.5,
    cal: 283,
    protein: 4,
    carbs: 20,
    fat: 21,
  },
  {
    name: 'Panna Cotta',
    category: 'Desserts',
    oz: 3.5,
    cal: 340,
    protein: 3,
    carbs: 20,
    fat: 28,
  },
  {
    name: 'Crème Brûlée',
    category: 'Desserts',
    oz: 3,
    cal: 320,
    protein: 5,
    carbs: 30,
    fat: 20,
  },
  {
    name: 'Chocolate Mousse',
    category: 'Desserts',
    oz: 3.5,
    cal: 360,
    protein: 3.5,
    carbs: 24,
    fat: 27,
  },
  {
    name: 'Banana Split',
    category: 'Desserts',
    oz: 10,
    cal: 510,
    protein: 8,
    carbs: 70,
    fat: 22,
  },
  {
    name: 'Sundae',
    category: 'Desserts',
    oz: 5.3,
    cal: 350,
    protein: 6,
    carbs: 48,
    fat: 16,
  },
  {
    name: 'Frozen Yogurt',
    category: 'Desserts',
    oz: 4.2,
    cal: 180,
    protein: 3,
    carbs: 35,
    fat: 2,
  },
  {
    name: 'Sorbet',
    category: 'Desserts',
    oz: 4.2,
    cal: 120,
    protein: 0,
    carbs: 31,
    fat: 0,
  },
  {
    name: 'Gelato',
    category: 'Desserts',
    oz: 4.2,
    cal: 220,
    protein: 4,
    carbs: 28,
    fat: 11,
  },
  {
    name: 'Popsicle',
    category: 'Desserts',
    oz: 2.5,
    cal: 85,
    protein: 0,
    carbs: 22,
    fat: 0,
  },
  {
    name: 'Cotton Candy',
    category: 'Desserts',
    oz: 1,
    cal: 340,
    protein: 0,
    carbs: 85,
    fat: 0,
  },
  {
    name: 'Candy Cane',
    category: 'Desserts',
    oz: 0.5,
    cal: 60,
    protein: 0,
    carbs: 15,
    fat: 0,
  },
  {
    name: 'Taffy',
    category: 'Desserts',
    oz: 0.5,
    cal: 54,
    protein: 0,
    carbs: 11,
    fat: 1.1,
  },
  {
    name: 'Gummy Bears',
    category: 'Desserts',
    oz: 1,
    cal: 340,
    protein: 0,
    carbs: 85,
    fat: 0,
  },
  {
    name: 'Licorice',
    category: 'Desserts',
    oz: 1,
    cal: 318,
    protein: 0,
    carbs: 81,
    fat: 0,
  },
  {
    name: 'Hard Candy',
    category: 'Desserts',
    oz: 1,
    cal: 387,
    protein: 0,
    carbs: 97,
    fat: 0,
  },

  // INTERNATIONAL CUISINE
  {
    name: 'Bibimbap',
    category: 'International',
    oz: 10,
    cal: 550,
    protein: 20,
    carbs: 60,
    fat: 25,
  },
  {
    name: 'Pho',
    category: 'International',
    oz: 12,
    cal: 220,
    protein: 15,
    carbs: 20,
    fat: 6,
  },
  {
    name: 'Ramen Bowl',
    category: 'International',
    oz: 12,
    cal: 450,
    protein: 18,
    carbs: 56,
    fat: 16,
  },
  {
    name: 'Udon Noodles',
    category: 'International',
    oz: 8,
    cal: 280,
    protein: 8,
    carbs: 52,
    fat: 2,
  },
  {
    name: 'Pad See Ew',
    category: 'International',
    oz: 9,
    cal: 380,
    protein: 16,
    carbs: 40,
    fat: 18,
  },
  {
    name: 'Green Curry',
    category: 'International',
    oz: 9,
    cal: 310,
    protein: 18,
    carbs: 12,
    fat: 22,
  },
  {
    name: 'Tom Yum Soup',
    category: 'International',
    oz: 10,
    cal: 160,
    protein: 12,
    carbs: 14,
    fat: 6,
  },
  {
    name: 'Falafel',
    category: 'International',
    oz: 3,
    cal: 242,
    protein: 8,
    carbs: 21,
    fat: 14,
  },
  {
    name: 'Hummus',
    category: 'International',
    oz: 2,
    cal: 186,
    protein: 6.4,
    carbs: 16.6,
    fat: 9.6,
  },
  {
    name: 'Tabbouleh',
    category: 'International',
    oz: 3.5,
    cal: 99,
    protein: 3.3,
    carbs: 15,
    fat: 3.5,
  },
  {
    name: 'Shawarma',
    category: 'International',
    oz: 5,
    cal: 350,
    protein: 28,
    carbs: 20,
    fat: 20,
  },
  {
    name: 'Kebab',
    category: 'International',
    oz: 4,
    cal: 280,
    protein: 24,
    carbs: 18,
    fat: 14,
  },
  {
    name: 'Tikka Masala',
    category: 'International',
    oz: 9,
    cal: 370,
    protein: 28,
    carbs: 18,
    fat: 22,
  },
  {
    name: 'Samosa',
    category: 'International',
    oz: 2,
    cal: 262,
    protein: 4,
    carbs: 32,
    fat: 12,
  },
  {
    name: 'Tandoori Chicken',
    category: 'International',
    oz: 4,
    cal: 158,
    protein: 26,
    carbs: 2,
    fat: 5,
  },
  {
    name: 'Naan with Butter',
    category: 'International',
    oz: 2,
    cal: 300,
    protein: 8,
    carbs: 42,
    fat: 10,
  },
  {
    name: 'Gyro Sandwich',
    category: 'International',
    oz: 6,
    cal: 480,
    protein: 32,
    carbs: 40,
    fat: 22,
  },
  {
    name: 'Empanada',
    category: 'International',
    oz: 3.5,
    cal: 350,
    protein: 10,
    carbs: 38,
    fat: 18,
  },
  {
    name: 'Arepa',
    category: 'International',
    oz: 3.5,
    cal: 320,
    protein: 8,
    carbs: 40,
    fat: 15,
  },
  {
    name: 'Enchilada',
    category: 'International',
    oz: 5,
    cal: 350,
    protein: 16,
    carbs: 35,
    fat: 18,
  },

  // BREAKFAST ITEMS
  {
    name: 'Scrambled Eggs',
    category: 'Breakfast',
    oz: 4,
    cal: 160,
    protein: 16,
    carbs: 1.5,
    fat: 10,
  },
  {
    name: 'Fried Eggs',
    category: 'Breakfast',
    oz: 3.5,
    cal: 210,
    protein: 16,
    carbs: 0,
    fat: 17,
  },
  {
    name: 'Omelet',
    category: 'Breakfast',
    oz: 4,
    cal: 240,
    protein: 18,
    carbs: 2,
    fat: 18,
  },
  {
    name: 'French Toast',
    category: 'Breakfast',
    oz: 3,
    cal: 220,
    protein: 6,
    carbs: 28,
    fat: 10,
  },
  {
    name: 'Waffles',
    category: 'Breakfast',
    oz: 2,
    cal: 220,
    protein: 6,
    carbs: 35,
    fat: 8,
  },
  {
    name: 'Breakfast Burrito',
    category: 'Breakfast',
    oz: 6,
    cal: 420,
    protein: 18,
    carbs: 38,
    fat: 22,
  },
  {
    name: 'Breakfast Sandwich',
    category: 'Breakfast',
    oz: 4,
    cal: 350,
    protein: 15,
    carbs: 30,
    fat: 18,
  },
  {
    name: 'Hash Browns',
    category: 'Breakfast',
    oz: 3,
    cal: 360,
    protein: 3,
    carbs: 36,
    fat: 23,
  },
  {
    name: 'Avocado Toast',
    category: 'Breakfast',
    oz: 3,
    cal: 280,
    protein: 8,
    carbs: 25,
    fat: 16,
  },
  {
    name: 'Granola Parfait',
    category: 'Breakfast',
    oz: 5,
    cal: 320,
    protein: 10,
    carbs: 44,
    fat: 10,
  },

  // SOUPS & BROTHS (ADDITIONAL)
  {
    name: 'Minestrone Soup',
    category: 'Soups',
    oz: 8,
    cal: 110,
    protein: 4,
    carbs: 20,
    fat: 1.5,
  },
  {
    name: 'Lentil Soup',
    category: 'Soups',
    oz: 8,
    cal: 130,
    protein: 9,
    carbs: 20,
    fat: 1,
  },
  {
    name: 'Split Pea Soup',
    category: 'Soups',
    oz: 8,
    cal: 150,
    protein: 8,
    carbs: 24,
    fat: 2,
  },
  {
    name: 'Potato Soup',
    category: 'Soups',
    oz: 8,
    cal: 220,
    protein: 4,
    carbs: 24,
    fat: 12,
  },
  {
    name: 'Cream of Mushroom',
    category: 'Soups',
    oz: 8,
    cal: 160,
    protein: 2,
    carbs: 8,
    fat: 12,
  },
  {
    name: 'Clam Chowder',
    category: 'Soups',
    oz: 8,
    cal: 200,
    protein: 8,
    carbs: 16,
    fat: 11,
  },
  {
    name: 'Lobster Bisque',
    category: 'Soups',
    oz: 8,
    cal: 320,
    protein: 12,
    carbs: 20,
    fat: 22,
  },
  {
    name: 'French Onion Soup',
    category: 'Soups',
    oz: 8,
    cal: 240,
    protein: 8,
    carbs: 18,
    fat: 14,
  },
  {
    name: 'Gazpacho',
    category: 'Soups',
    oz: 8,
    cal: 100,
    protein: 2,
    carbs: 18,
    fat: 3,
  },
  {
    name: 'Mulligatawny',
    category: 'Soups',
    oz: 8,
    cal: 240,
    protein: 10,
    carbs: 20,
    fat: 12,
  },

  // SAUCES & CONDIMENTS (ADDITIONAL)
  {
    name: 'BBQ Sauce',
    category: 'Condiments',
    oz: 0.5,
    cal: 48,
    protein: 0,
    carbs: 12,
    fat: 0,
  },
  {
    name: 'Sriracha',
    category: 'Condiments',
    oz: 0.5,
    cal: 17,
    protein: 0.5,
    carbs: 3,
    fat: 0.5,
  },
  {
    name: 'Hot Sauce',
    category: 'Condiments',
    oz: 0.5,
    cal: 3,
    protein: 0,
    carbs: 0.6,
    fat: 0,
  },
  {
    name: 'Salsa',
    category: 'Condiments',
    oz: 2,
    cal: 28,
    protein: 1,
    carbs: 6,
    fat: 0.1,
  },
  {
    name: 'Guacamole',
    category: 'Condiments',
    oz: 2,
    cal: 96,
    protein: 1.3,
    carbs: 4.5,
    fat: 8.6,
  },
  {
    name: 'Pesto',
    category: 'Condiments',
    oz: 0.5,
    cal: 160,
    protein: 5.6,
    carbs: 3,
    fat: 15,
  },
  {
    name: 'Hummus',
    category: 'Condiments',
    oz: 2,
    cal: 180,
    protein: 6,
    carbs: 16,
    fat: 9,
  },
  {
    name: 'Vinaigrette',
    category: 'Condiments',
    oz: 0.5,
    cal: 120,
    protein: 0,
    carbs: 1,
    fat: 13,
  },
  {
    name: 'Ranch Dressing',
    category: 'Condiments',
    oz: 2,
    cal: 220,
    protein: 1,
    carbs: 3,
    fat: 23,
  },
  {
    name: 'Caesar Dressing',
    category: 'Condiments',
    oz: 2,
    cal: 280,
    protein: 2,
    carbs: 3,
    fat: 29,
  },

  // PREPARED MEALS
  {
    name: 'Lasagna',
    category: 'Prepared',
    oz: 8,
    cal: 420,
    protein: 20,
    carbs: 40,
    fat: 18,
  },
  {
    name: 'Baked Mac & Cheese',
    category: 'Prepared',
    oz: 6,
    cal: 480,
    protein: 18,
    carbs: 48,
    fat: 22,
  },
  {
    name: 'Beef Stew',
    category: 'Prepared',
    oz: 8,
    cal: 220,
    protein: 24,
    carbs: 16,
    fat: 8,
  },
  {
    name: 'Chicken Pot Pie',
    category: 'Prepared',
    oz: 8,
    cal: 460,
    protein: 18,
    carbs: 42,
    fat: 24,
  },
  {
    name: 'Meatloaf',
    category: 'Prepared',
    oz: 4,
    cal: 360,
    protein: 28,
    carbs: 8,
    fat: 26,
  },
  {
    name: 'Roasted Turkey',
    category: 'Prepared',
    oz: 4,
    cal: 220,
    protein: 32,
    carbs: 0,
    fat: 10,
  },
  {
    name: 'Roasted Chicken',
    category: 'Prepared',
    oz: 4,
    cal: 240,
    protein: 30,
    carbs: 0,
    fat: 12,
  },
  {
    name: 'Fish & Chips',
    category: 'Prepared',
    oz: 8,
    cal: 500,
    protein: 20,
    carbs: 50,
    fat: 24,
  },
  {
    name: 'Salisbury Steak',
    category: 'Prepared',
    oz: 5,
    cal: 380,
    protein: 30,
    carbs: 12,
    fat: 24,
  },
  {
    name: 'Chicken Parmesan',
    category: 'Prepared',
    oz: 6,
    cal: 480,
    protein: 36,
    carbs: 24,
    fat: 26,
  },

  // ADDITIONAL PROTEINS - BEANS & LEGUMES
  {
    name: 'Chickpeas',
    category: 'Protein',
    oz: 3.5,
    cal: 364,
    protein: 19,
    carbs: 61,
    fat: 6,
  },
  {
    name: 'Black Beans',
    category: 'Protein',
    oz: 3.5,
    cal: 132,
    protein: 8.9,
    carbs: 24,
    fat: 0.5,
  },
  {
    name: 'Kidney Beans',
    category: 'Protein',
    oz: 3.5,
    cal: 127,
    protein: 8.7,
    carbs: 23,
    fat: 0.4,
  },
  {
    name: 'Pinto Beans',
    category: 'Protein',
    oz: 3.5,
    cal: 143,
    protein: 8.4,
    carbs: 27,
    fat: 0.6,
  },
  {
    name: 'White Beans',
    category: 'Protein',
    oz: 3.5,
    cal: 149,
    protein: 9,
    carbs: 27,
    fat: 0.5,
  },
  {
    name: 'Lima Beans',
    category: 'Protein',
    oz: 3.5,
    cal: 115,
    protein: 7.8,
    carbs: 20,
    fat: 0.4,
  },
  {
    name: 'Black-eyed Peas',
    category: 'Protein',
    oz: 3.5,
    cal: 116,
    protein: 8,
    carbs: 20,
    fat: 0.5,
  },
  {
    name: 'Lentils',
    category: 'Protein',
    oz: 3.5,
    cal: 353,
    protein: 25,
    carbs: 63,
    fat: 1.1,
  },
  {
    name: 'Tofu',
    category: 'Protein',
    oz: 3.5,
    cal: 76,
    protein: 8.1,
    carbs: 1.9,
    fat: 4.8,
  },
  {
    name: 'Tempeh',
    category: 'Protein',
    oz: 3,
    cal: 162,
    protein: 19,
    carbs: 9,
    fat: 9,
  },
  {
    name: 'Edamame',
    category: 'Protein',
    oz: 3.5,
    cal: 111,
    protein: 11,
    carbs: 10,
    fat: 5,
  },
  {
    name: 'Seitan',
    category: 'Protein',
    oz: 3.5,
    cal: 370,
    protein: 25,
    carbs: 9,
    fat: 17,
  },

  // ADDITIONAL VEGETABLES
  {
    name: 'Asparagus',
    category: 'Vegetables',
    oz: 3.5,
    cal: 27,
    protein: 3,
    carbs: 5,
    fat: 0.1,
  },
  {
    name: 'Jicama',
    category: 'Vegetables',
    oz: 3.5,
    cal: 38,
    protein: 0.7,
    carbs: 8.5,
    fat: 0.1,
  },
  {
    name: 'Daikon',
    category: 'Vegetables',
    oz: 3.5,
    cal: 18,
    protein: 0.6,
    carbs: 3.5,
    fat: 0.1,
  },
  {
    name: 'Kohlrabi',
    category: 'Vegetables',
    oz: 3.5,
    cal: 27,
    protein: 1.7,
    carbs: 6.2,
    fat: 0.1,
  },
  {
    name: 'Taro',
    category: 'Vegetables',
    oz: 3.5,
    cal: 112,
    protein: 1.5,
    carbs: 27,
    fat: 0.2,
  },

  // COFFEE & TEA DRINKS
  {
    name: 'Black Coffee',
    category: 'Beverages',
    oz: 8,
    cal: 2,
    protein: 0.3,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Espresso',
    category: 'Beverages',
    oz: 1,
    cal: 3,
    protein: 0.1,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Latte',
    category: 'Beverages',
    oz: 10,
    cal: 190,
    protein: 13,
    carbs: 18,
    fat: 7,
  },
  {
    name: 'Cappuccino',
    category: 'Beverages',
    oz: 8,
    cal: 150,
    protein: 10,
    carbs: 11,
    fat: 5,
  },
  {
    name: 'Macchiato',
    category: 'Beverages',
    oz: 3,
    cal: 8,
    protein: 0.5,
    carbs: 0.5,
    fat: 0.5,
  },
  {
    name: 'Mocha',
    category: 'Beverages',
    oz: 10,
    cal: 280,
    protein: 10,
    carbs: 38,
    fat: 10,
  },
  {
    name: 'Americano',
    category: 'Beverages',
    oz: 8,
    cal: 15,
    protein: 1,
    carbs: 1,
    fat: 0,
  },
  {
    name: 'Green Tea',
    category: 'Beverages',
    oz: 8,
    cal: 25,
    protein: 0,
    carbs: 6,
    fat: 0,
  },
  {
    name: 'Black Tea',
    category: 'Beverages',
    oz: 8,
    cal: 27,
    protein: 0,
    carbs: 5,
    fat: 0,
  },
  {
    name: 'Herbal Tea',
    category: 'Beverages',
    oz: 8,
    cal: 2,
    protein: 0,
    carbs: 0.4,
    fat: 0,
  },
  {
    name: 'Matcha Latte',
    category: 'Beverages',
    oz: 10,
    cal: 240,
    protein: 9,
    carbs: 32,
    fat: 6,
  },
  {
    name: 'Chai Latte',
    category: 'Beverages',
    oz: 10,
    cal: 240,
    protein: 10,
    carbs: 35,
    fat: 5,
  },

  // ADDITIONAL FRUITS
  {
    name: 'Mulberry',
    category: 'Fruits',
    oz: 3.5,
    cal: 43,
    protein: 1.4,
    carbs: 10,
    fat: 0.4,
  },
  {
    name: 'Acai Berry',
    category: 'Fruits',
    oz: 3.5,
    cal: 70,
    protein: 1.5,
    carbs: 4.6,
    fat: 5,
  },
  {
    name: 'Goji Berry',
    category: 'Fruits',
    oz: 1,
    cal: 352,
    protein: 14,
    carbs: 77,
    fat: 1.5,
  },
  {
    name: 'Blueberry',
    category: 'Fruits',
    oz: 3.5,
    cal: 57,
    protein: 0.7,
    carbs: 14,
    fat: 0.3,
  },
  {
    name: 'Strawberry',
    category: 'Fruits',
    oz: 3.5,
    cal: 32,
    protein: 0.6,
    carbs: 7.7,
    fat: 0.3,
  },

  // MORE ASIAN FOODS
  {
    name: 'Spring Roll',
    category: 'International',
    oz: 2.5,
    cal: 141,
    protein: 4,
    carbs: 18,
    fat: 6,
  },
  {
    name: 'Dumpling',
    category: 'International',
    oz: 1.5,
    cal: 60,
    protein: 2,
    carbs: 7,
    fat: 2.5,
  },
  {
    name: 'Sushi Roll',
    category: 'International',
    oz: 3.5,
    cal: 200,
    protein: 8,
    carbs: 32,
    fat: 5,
  },
  {
    name: 'Miso Soup',
    category: 'International',
    oz: 8,
    cal: 84,
    protein: 8,
    carbs: 6,
    fat: 3,
  },
  {
    name: 'Edamame (Appetizer)',
    category: 'International',
    oz: 3.5,
    cal: 111,
    protein: 11,
    carbs: 10,
    fat: 5,
  },
  {
    name: 'Sashimi',
    category: 'International',
    oz: 3.5,
    cal: 140,
    protein: 21,
    carbs: 0,
    fat: 6,
  },
  {
    name: 'Tempura',
    category: 'International',
    oz: 4,
    cal: 280,
    protein: 8,
    carbs: 24,
    fat: 16,
  },
  {
    name: 'Teriyaki Chicken',
    category: 'International',
    oz: 4,
    cal: 280,
    protein: 24,
    carbs: 22,
    fat: 11,
  },
  {
    name: 'Panang Curry',
    category: 'International',
    oz: 9,
    cal: 380,
    protein: 16,
    carbs: 14,
    fat: 28,
  },
  {
    name: 'Massaman Curry',
    category: 'International',
    oz: 9,
    cal: 420,
    protein: 18,
    carbs: 18,
    fat: 32,
  },

  // MEXICAN CUISINE
  {
    name: 'Burrito',
    category: 'International',
    oz: 8,
    cal: 540,
    protein: 20,
    carbs: 60,
    fat: 22,
  },
  {
    name: 'Quesadilla',
    category: 'International',
    oz: 6,
    cal: 480,
    protein: 18,
    carbs: 36,
    fat: 28,
  },
  {
    name: 'Taco',
    category: 'International',
    oz: 2,
    cal: 170,
    protein: 9,
    carbs: 14,
    fat: 8,
  },
  {
    name: 'Chiles Rellenos',
    category: 'International',
    oz: 8,
    cal: 420,
    protein: 16,
    carbs: 24,
    fat: 28,
  },
  {
    name: 'Elote',
    category: 'International',
    oz: 4,
    cal: 160,
    protein: 4,
    carbs: 18,
    fat: 8,
  },
  {
    name: 'Ceviche',
    category: 'International',
    oz: 4,
    cal: 120,
    protein: 18,
    carbs: 8,
    fat: 2,
  },
  {
    name: 'Carne Asada',
    category: 'International',
    oz: 4,
    cal: 280,
    protein: 35,
    carbs: 0,
    fat: 14,
  },
  {
    name: 'Barbacoa',
    category: 'International',
    oz: 4,
    cal: 280,
    protein: 32,
    carbs: 2,
    fat: 16,
  },
  {
    name: 'Carnitas',
    category: 'International',
    oz: 4,
    cal: 340,
    protein: 28,
    carbs: 0,
    fat: 26,
  },
  {
    name: 'Chile con Carne',
    category: 'International',
    oz: 8,
    cal: 350,
    protein: 24,
    carbs: 18,
    fat: 20,
  },

  // INDIAN CUISINE
  {
    name: 'Biryani',
    category: 'International',
    oz: 8,
    cal: 420,
    protein: 18,
    carbs: 48,
    fat: 16,
  },
  {
    name: 'Butter Chicken',
    category: 'International',
    oz: 7,
    cal: 380,
    protein: 28,
    carbs: 10,
    fat: 26,
  },
  {
    name: 'Saag Paneer',
    category: 'International',
    oz: 6,
    cal: 280,
    protein: 15,
    carbs: 8,
    fat: 20,
  },
  {
    name: 'Dal',
    category: 'International',
    oz: 8,
    cal: 200,
    protein: 14,
    carbs: 32,
    fat: 3,
  },
  {
    name: 'Aloo Gobi',
    category: 'International',
    oz: 6,
    cal: 160,
    protein: 4,
    carbs: 18,
    fat: 8,
  },
  {
    name: 'Pakora',
    category: 'International',
    oz: 2,
    cal: 180,
    protein: 4,
    carbs: 18,
    fat: 10,
  },
  {
    name: 'Dosa',
    category: 'International',
    oz: 4,
    cal: 220,
    protein: 4,
    carbs: 40,
    fat: 5,
  },
  {
    name: 'Idli',
    category: 'International',
    oz: 2,
    cal: 60,
    protein: 2,
    carbs: 12,
    fat: 0.5,
  },
  {
    name: 'Uttapam',
    category: 'International',
    oz: 4,
    cal: 160,
    protein: 4,
    carbs: 30,
    fat: 3,
  },
  {
    name: 'Dhokla',
    category: 'International',
    oz: 3,
    cal: 180,
    protein: 6,
    carbs: 30,
    fat: 3,
  },

  // ITALIAN CUISINE
  {
    name: 'Spaghetti Carbonara',
    category: 'International',
    oz: 8,
    cal: 580,
    protein: 24,
    carbs: 48,
    fat: 30,
  },
  {
    name: 'Risotto',
    category: 'International',
    oz: 8,
    cal: 400,
    protein: 12,
    carbs: 50,
    fat: 14,
  },
  {
    name: 'Minestrone',
    category: 'International',
    oz: 8,
    cal: 110,
    protein: 4,
    carbs: 20,
    fat: 1.5,
  },
  {
    name: 'Polenta',
    category: 'International',
    oz: 4,
    cal: 160,
    protein: 3,
    carbs: 30,
    fat: 2,
  },
  {
    name: 'Osso Buco',
    category: 'International',
    oz: 6,
    cal: 360,
    protein: 38,
    carbs: 6,
    fat: 20,
  },
  {
    name: 'Ravioli',
    category: 'International',
    oz: 4,
    cal: 220,
    protein: 8,
    carbs: 26,
    fat: 10,
  },
  {
    name: 'Tortellini',
    category: 'International',
    oz: 4,
    cal: 280,
    protein: 12,
    carbs: 32,
    fat: 12,
  },
  {
    name: 'Gnocchi',
    category: 'International',
    oz: 4,
    cal: 180,
    protein: 4,
    carbs: 36,
    fat: 2,
  },
  {
    name: 'Cacio e Pepe',
    category: 'International',
    oz: 7,
    cal: 540,
    protein: 18,
    carbs: 48,
    fat: 28,
  },
  {
    name: 'Pasta Primavera',
    category: 'International',
    oz: 8,
    cal: 340,
    protein: 12,
    carbs: 48,
    fat: 12,
  },

  // FRENCH CUISINE
  {
    name: 'Coq au Vin',
    category: 'International',
    oz: 8,
    cal: 420,
    protein: 38,
    carbs: 8,
    fat: 24,
  },
  {
    name: 'Beef Bourguignon',
    category: 'International',
    oz: 8,
    cal: 480,
    protein: 42,
    carbs: 10,
    fat: 28,
  },
  {
    name: 'Escargot',
    category: 'International',
    oz: 3,
    cal: 90,
    protein: 16,
    carbs: 2,
    fat: 2,
  },
  {
    name: 'Duck Confit',
    category: 'International',
    oz: 5,
    cal: 520,
    protein: 35,
    carbs: 0,
    fat: 42,
  },
  {
    name: 'Ratatouille',
    category: 'International',
    oz: 6,
    cal: 120,
    protein: 3,
    carbs: 16,
    fat: 6,
  },
  {
    name: 'Boeuf Stroganoff',
    category: 'International',
    oz: 8,
    cal: 420,
    protein: 36,
    carbs: 18,
    fat: 22,
  },
  {
    name: 'Crepes',
    category: 'International',
    oz: 2.5,
    cal: 220,
    protein: 5,
    carbs: 28,
    fat: 10,
  },
  {
    name: 'Quiche',
    category: 'International',
    oz: 5,
    cal: 380,
    protein: 14,
    carbs: 24,
    fat: 26,
  },
  {
    name: 'Bouillabaisse',
    category: 'International',
    oz: 10,
    cal: 280,
    protein: 28,
    carbs: 12,
    fat: 12,
  },
  {
    name: 'Cassoulet',
    category: 'International',
    oz: 8,
    cal: 540,
    protein: 32,
    carbs: 28,
    fat: 32,
  },

  // MORE DESSERTS & BAKED GOODS
  {
    name: 'Apple Pie',
    category: 'Desserts',
    oz: 3,
    cal: 280,
    protein: 2,
    carbs: 42,
    fat: 12,
  },
  {
    name: 'Cheesecake',
    category: 'Desserts',
    oz: 3,
    cal: 380,
    protein: 6,
    carbs: 32,
    fat: 27,
  },
  {
    name: 'Chocolate Cake',
    category: 'Desserts',
    oz: 2,
    cal: 340,
    protein: 4,
    carbs: 46,
    fat: 16,
  },
  {
    name: 'Carrot Cake',
    category: 'Desserts',
    oz: 2,
    cal: 380,
    protein: 3,
    carbs: 46,
    fat: 20,
  },
  {
    name: 'Red Velvet Cake',
    category: 'Desserts',
    oz: 2,
    cal: 340,
    protein: 3,
    carbs: 42,
    fat: 18,
  },
  {
    name: 'Black Forest Cake',
    category: 'Desserts',
    oz: 3,
    cal: 420,
    protein: 4,
    carbs: 48,
    fat: 24,
  },
  {
    name: 'Tres Leches Cake',
    category: 'Desserts',
    oz: 3,
    cal: 360,
    protein: 5,
    carbs: 48,
    fat: 16,
  },
  {
    name: 'Lava Cake',
    category: 'Desserts',
    oz: 2,
    cal: 380,
    protein: 4,
    carbs: 42,
    fat: 22,
  },
  {
    name: 'Cheesecake Brownie',
    category: 'Desserts',
    oz: 2,
    cal: 420,
    protein: 5,
    carbs: 48,
    fat: 24,
  },
  {
    name: 'Donut',
    category: 'Desserts',
    oz: 1.8,
    cal: 250,
    protein: 3,
    carbs: 32,
    fat: 12,
  },

  // CUPCAKES & PASTRIES
  {
    name: 'Cupcake',
    category: 'Desserts',
    oz: 1.8,
    cal: 280,
    protein: 2,
    carbs: 36,
    fat: 14,
  },
  {
    name: 'Croissant',
    category: 'Breakfast',
    oz: 2,
    cal: 406,
    protein: 9,
    carbs: 41,
    fat: 21,
  },
  {
    name: 'Pastry',
    category: 'Desserts',
    oz: 2,
    cal: 320,
    protein: 4,
    carbs: 38,
    fat: 16,
  },
  {
    name: 'Muffin',
    category: 'Breakfast',
    oz: 2,
    cal: 320,
    protein: 3,
    carbs: 40,
    fat: 16,
  },
  {
    name: 'Bagel',
    category: 'Breakfast',
    oz: 3.5,
    cal: 245,
    protein: 9,
    carbs: 48,
    fat: 1,
  },
  {
    name: 'Scone',
    category: 'Breakfast',
    oz: 2,
    cal: 360,
    protein: 6,
    carbs: 40,
    fat: 18,
  },
  {
    name: 'Danish Pastry',
    category: 'Breakfast',
    oz: 2.5,
    cal: 400,
    protein: 6,
    carbs: 44,
    fat: 20,
  },
  {
    name: 'Cinnamon Roll',
    category: 'Breakfast',
    oz: 3,
    cal: 480,
    protein: 7,
    carbs: 60,
    fat: 24,
  },
  {
    name: 'Donut Hole',
    category: 'Desserts',
    oz: 0.5,
    cal: 70,
    protein: 0.7,
    carbs: 9,
    fat: 3.5,
  },
  {
    name: 'Churro',
    category: 'Desserts',
    oz: 1.5,
    cal: 250,
    protein: 1.5,
    carbs: 28,
    fat: 14,
  },

  // ADDITIONAL PROTEINS
  {
    name: 'Ground Turkey',
    category: 'Protein',
    oz: 3.5,
    cal: 200,
    protein: 26,
    carbs: 0,
    fat: 10,
  },
  {
    name: 'Ground Beef',
    category: 'Protein',
    oz: 3.5,
    cal: 217,
    protein: 23,
    carbs: 0,
    fat: 13,
  },
  {
    name: 'Ground Chicken',
    category: 'Protein',
    oz: 3.5,
    cal: 170,
    protein: 28,
    carbs: 0,
    fat: 6,
  },
  {
    name: 'Pork Chop',
    category: 'Protein',
    oz: 3.5,
    cal: 242,
    protein: 27,
    carbs: 0,
    fat: 14,
  },
  {
    name: 'Pork Tenderloin',
    category: 'Protein',
    oz: 3.5,
    cal: 180,
    protein: 26,
    carbs: 0,
    fat: 8,
  },
  {
    name: 'Pork Belly',
    category: 'Protein',
    oz: 3.5,
    cal: 518,
    protein: 10.2,
    carbs: 0,
    fat: 53,
  },
  {
    name: 'Ribs',
    category: 'Protein',
    oz: 3.5,
    cal: 293,
    protein: 26,
    carbs: 0,
    fat: 21,
  },

  // MORE VEGETABLES
  {
    name: 'Celery Root',
    category: 'Vegetables',
    oz: 3.5,
    cal: 42,
    protein: 1.5,
    carbs: 9,
    fat: 0.3,
  },
  {
    name: 'Watercress',
    category: 'Vegetables',
    oz: 3.5,
    cal: 25,
    protein: 2.3,
    carbs: 3.6,
    fat: 0.1,
  },
  {
    name: 'Bamboo Shoots',
    category: 'Vegetables',
    oz: 3.5,
    cal: 27,
    protein: 2.6,
    carbs: 5.2,
    fat: 0.3,
  },
  {
    name: 'Hearts of Palm',
    category: 'Vegetables',
    oz: 3.5,
    cal: 25,
    protein: 2.4,
    carbs: 4.6,
    fat: 0.3,
  },
  {
    name: 'Sunchoke',
    category: 'Vegetables',
    oz: 3.5,
    cal: 73,
    protein: 2.4,
    carbs: 17.4,
    fat: 0.1,
  },

  // PIZZA & FLATBREADS
  {
    name: 'Margherita Pizza',
    category: 'Prepared',
    oz: 4,
    cal: 350,
    protein: 14,
    carbs: 36,
    fat: 16,
  },
  {
    name: 'Pepperoni Pizza',
    category: 'Prepared',
    oz: 4,
    cal: 420,
    protein: 16,
    carbs: 36,
    fat: 22,
  },
  {
    name: 'Vegetarian Pizza',
    category: 'Prepared',
    oz: 4,
    cal: 320,
    protein: 12,
    carbs: 38,
    fat: 14,
  },
  {
    name: 'BBQ Chicken Pizza',
    category: 'Prepared',
    oz: 4,
    cal: 380,
    protein: 18,
    carbs: 38,
    fat: 16,
  },
  {
    name: 'White Pizza',
    category: 'Prepared',
    oz: 4,
    cal: 420,
    protein: 16,
    carbs: 32,
    fat: 24,
  },

  // COMFORT FOOD
  {
    name: 'Mashed Potatoes',
    category: 'Prepared',
    oz: 4,
    cal: 150,
    protein: 2,
    carbs: 18,
    fat: 7,
  },
  {
    name: 'Sweet Potato Fries',
    category: 'Prepared',
    oz: 3.5,
    cal: 320,
    protein: 3,
    carbs: 40,
    fat: 15,
  },
  {
    name: 'Grilled Cheese Sandwich',
    category: 'Prepared',
    oz: 3,
    cal: 380,
    protein: 14,
    carbs: 28,
    fat: 24,
  },
  {
    name: 'BLT Sandwich',
    category: 'Prepared',
    oz: 4,
    cal: 360,
    protein: 12,
    carbs: 32,
    fat: 20,
  },
  {
    name: 'Club Sandwich',
    category: 'Prepared',
    oz: 6,
    cal: 520,
    protein: 28,
    carbs: 40,
    fat: 28,
  },

  // ASIAN SOUPS & BROTHS
  {
    name: 'Wonton Soup',
    category: 'Soups',
    oz: 8,
    cal: 180,
    protein: 10,
    carbs: 18,
    fat: 6,
  },
  {
    name: 'Hot and Sour Soup',
    category: 'Soups',
    oz: 8,
    cal: 160,
    protein: 8,
    carbs: 12,
    fat: 8,
  },
  {
    name: 'Miso Ramen Soup',
    category: 'Soups',
    oz: 10,
    cal: 380,
    protein: 14,
    carbs: 44,
    fat: 14,
  },
  {
    name: 'Vietnamese Beef Pho',
    category: 'Soups',
    oz: 12,
    cal: 240,
    protein: 18,
    carbs: 22,
    fat: 8,
  },
  {
    name: 'Tom Kha Gai',
    category: 'Soups',
    oz: 9,
    cal: 320,
    protein: 14,
    carbs: 14,
    fat: 24,
  },

  // SALADS
  {
    name: 'Caesar Salad',
    category: 'Prepared',
    oz: 8,
    cal: 360,
    protein: 12,
    carbs: 18,
    fat: 28,
  },
  {
    name: 'Greek Salad',
    category: 'Prepared',
    oz: 8,
    cal: 280,
    protein: 10,
    carbs: 18,
    fat: 20,
  },
  {
    name: 'Garden Salad',
    category: 'Prepared',
    oz: 6,
    cal: 120,
    protein: 4,
    carbs: 12,
    fat: 6,
  },
  {
    name: 'Caprese Salad',
    category: 'Prepared',
    oz: 6,
    cal: 240,
    protein: 10,
    carbs: 8,
    fat: 18,
  },
  {
    name: 'Spinach Salad',
    category: 'Prepared',
    oz: 6,
    cal: 280,
    protein: 8,
    carbs: 14,
    fat: 22,
  },

  // SNACKS - HEALTHY OPTIONS
  {
    name: 'Almonds',
    category: 'Snacks',
    oz: 1,
    cal: 160,
    protein: 6,
    carbs: 6,
    fat: 14,
  },
  {
    name: 'Cashews',
    category: 'Snacks',
    oz: 1,
    cal: 155,
    protein: 5,
    carbs: 9,
    fat: 12,
  },
  {
    name: 'Walnuts',
    category: 'Snacks',
    oz: 1,
    cal: 185,
    protein: 4.3,
    carbs: 4.2,
    fat: 18.5,
  },
  {
    name: 'Granola Bar',
    category: 'Snacks',
    oz: 1.4,
    cal: 170,
    protein: 4,
    carbs: 24,
    fat: 6,
  },
  {
    name: 'Protein Bar',
    category: 'Snacks',
    oz: 1.6,
    cal: 200,
    protein: 20,
    carbs: 12,
    fat: 7,
  },
  {
    name: 'Trail Mix',
    category: 'Snacks',
    oz: 1,
    cal: 150,
    protein: 4,
    carbs: 15,
    fat: 8,
  },
  {
    name: 'Dark Chocolate',
    category: 'Snacks',
    oz: 1,
    cal: 170,
    protein: 3,
    carbs: 16,
    fat: 12,
  },
  {
    name: 'Popcorn',
    category: 'Snacks',
    oz: 1,
    cal: 111,
    protein: 3.5,
    carbs: 11,
    fat: 6,
  },
  {
    name: 'Pretzel',
    category: 'Snacks',
    oz: 1,
    cal: 108,
    protein: 3,
    carbs: 21,
    fat: 1,
  },
  {
    name: 'Granola',
    category: 'Snacks',
    oz: 1,
    cal: 152,
    protein: 4,
    carbs: 18,
    fat: 7,
  },

  // BEVERAGES - MORE VARIETY
  {
    name: 'Banana Smoothie',
    category: 'Beverages',
    oz: 10,
    cal: 320,
    protein: 8,
    carbs: 52,
    fat: 6,
  },
  {
    name: 'Strawberry Smoothie',
    category: 'Beverages',
    oz: 10,
    cal: 280,
    protein: 6,
    carbs: 48,
    fat: 5,
  },
  {
    name: 'Protein Smoothie',
    category: 'Beverages',
    oz: 10,
    cal: 280,
    protein: 25,
    carbs: 24,
    fat: 6,
  },
  {
    name: 'Green Smoothie',
    category: 'Beverages',
    oz: 10,
    cal: 200,
    protein: 6,
    carbs: 32,
    fat: 4,
  },
  {
    name: 'Acai Bowl Smoothie',
    category: 'Beverages',
    oz: 10,
    cal: 320,
    protein: 8,
    carbs: 58,
    fat: 8,
  },
  {
    name: 'Mango Juice',
    category: 'Beverages',
    oz: 8,
    cal: 107,
    protein: 0.7,
    carbs: 25,
    fat: 0.4,
  },
  {
    name: 'Peach Juice',
    category: 'Beverages',
    oz: 8,
    cal: 120,
    protein: 1.5,
    carbs: 29,
    fat: 0.1,
  },
  {
    name: 'Pineapple Juice',
    category: 'Beverages',
    oz: 8,
    cal: 132,
    protein: 1,
    carbs: 32,
    fat: 0.3,
  },
  {
    name: 'Watermelon Juice',
    category: 'Beverages',
    oz: 8,
    cal: 46,
    protein: 0.9,
    carbs: 11,
    fat: 0.2,
  },
  {
    name: 'Beet Juice',
    category: 'Beverages',
    oz: 8,
    cal: 65,
    protein: 2,
    carbs: 16,
    fat: 0.2,
  },

  // ALCOHOL
  {
    name: 'Light Beer',
    category: 'Beverages',
    oz: 12,
    cal: 103,
    protein: 0.6,
    carbs: 3.2,
    fat: 0,
  },
  {
    name: 'Regular Beer',
    category: 'Beverages',
    oz: 12,
    cal: 153,
    protein: 1.6,
    carbs: 10.6,
    fat: 0,
  },
  {
    name: 'IPA Beer',
    category: 'Beverages',
    oz: 12,
    cal: 180,
    protein: 1.5,
    carbs: 15,
    fat: 0,
  },
  {
    name: 'Wine (Red)',
    category: 'Beverages',
    oz: 5,
    cal: 125,
    protein: 0.1,
    carbs: 3.8,
    fat: 0,
  },
  {
    name: 'Wine (White)',
    category: 'Beverages',
    oz: 5,
    cal: 121,
    protein: 0.1,
    carbs: 3.8,
    fat: 0,
  },
  {
    name: 'Champagne',
    category: 'Beverages',
    oz: 5,
    cal: 90,
    protein: 0,
    carbs: 1.5,
    fat: 0,
  },
  {
    name: 'Vodka',
    category: 'Beverages',
    oz: 1.5,
    cal: 103,
    protein: 0,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Whiskey',
    category: 'Beverages',
    oz: 1.5,
    cal: 110,
    protein: 0,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Rum',
    category: 'Beverages',
    oz: 1.5,
    cal: 110,
    protein: 0,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Tequila',
    category: 'Beverages',
    oz: 1.5,
    cal: 110,
    protein: 0,
    carbs: 0,
    fat: 0,
  },
];
